<template>
  <v-container fluid class="pa-0">
    <v-card flat>
      <v-card-text class="text-center">
        <v-row no-gutters>
          <v-col cols="12">
            <highcharts class="mt-4 w-100" :options="downtimeByMachineOptions"></highcharts>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'DowntimeByMachine',
  components: {
  },
  data() {
    return {
      tab: 0,
      downtimeByMachineOptions: {},
    };
  },
  computed: {
    ...mapState('helper', ['isDark']),
    ...mapState('bottleneckMachineDashboard', [
      'loading',
      'downtimeByMachine',
    ]),
    notFoundIllustration() {
      return this.$vuetify.theme.dark
        ? 'not-found-dark'
        : 'not-found-light';
    },
  },
  methods: {
    roundOff(val) {
      if (val) {
        return Math.round((val + Number.EPSILON) * 100) / 100;
      }
      return 0;
    },
    getColor(number) {
      let color = 'warning';
      if (number > 0) {
        color = 'success';
      } else if (number < 0) {
        color = 'error';
      }
      return color;
    },
    getIcon(number) {
      let icon = 'mdi-minus';
      if (number > 0) {
        icon = 'mdi-menu-up';
      } else if (number < 0) {
        icon = 'mdi-menu-down';
      }
      return icon;
    },
    setOptions(options) {
      const opt = { ...options };
      opt.title.style = {};
      opt.title.text = 'Downtime By Machine';
      opt.title.style = {
        color: this.isDark ? '#FFFFFF' : '#333333',
        fontSize: '1.5rem',
        fontFamily: 'Poppins, sans-serif',
      };
      opt.yAxis = options.yAxis.map((axis) => {
        const labels = {
          style: {
            color: this.isDark ? '#FFFFFF' : '#666666',
            fontSize: '1.2rem',
            fontFamily: 'Poppins, sans-serif',
          },
        };
        if (axis.labels) {
          return { ...axis, labels: { ...axis.labels, ...labels }, gridLineWidth: 0 };
        }
        return {
          ...axis,
          labels,
          gridLineWidth: 0,
        };
      });
      opt.yAxis[0].title.text = 'Downtime (in mins)';
      opt.yAxis[0].gridLineWidth = 0;
      opt.yAxis[0].title.style = {
        color: this.isDark ? '#FFFFFF' : '#666666',
        fontSize: '1.2rem',
        fontFamily: 'Poppins, sans-serif',
      };
      opt.yAxis[1].title.text = 'Contribution %';
      opt.yAxis[0].gridLineWidth = 0;
      opt.yAxis[1].title.style = {
        color: this.isDark ? '#FFFFFF' : '#666666',
        fontSize: '1.2rem',
        fontFamily: 'Poppins, sans-serif',
      };
      opt.xAxis.labels = {};
      opt.xAxis.labels.style = {};
      opt.xAxis.labels.style = {
        color: this.isDark ? '#FFFFFF' : '#666666',
        fontSize: '1.2rem',
        fontFamily: 'Poppins, sans-serif',
      };
      opt.series[0].color = '#063d90';
      opt.series[1].color = '#7cb5ec';
      return opt;
    },
  },
  watch: {
    downtimeByMachine(val) {
      this.downtimeByMachineOptions = this.setOptions(val);
    },

    isDark() {
      this.downtimeByReasonOptions = this.setOptions(this.downtimeByReason);
    },
  },
};
</script>

<style>
.v-progress-circular .v-progress-circular__info {
  display: block;
}
</style>
